import { writable } from "svelte/store";
import L1 from '../components/lessons/TSPIntroduction.svelte';
import L2 from "../components/lessons/GraphTheory.svelte";
import L3 from "../components/lessons/QUBOIntroduction.svelte";
import L4 from "../components/lessons/QuantumAnnealers.svelte";
import Demo from "../components/lessons/Demo.svelte";
import L5 from "../components/lessons/TSPQuantum.svelte";
import L6 from "../components/lessons/QUBOFormulating.svelte";
import L7 from "../components/lessons/CoefficientsToMatrix.svelte";
import L8 from "../components/lessons/HowToDesign.svelte";
import L9 from "../components/lessons/ExperimentalResults.svelte";
import L10 from "../components/lessons/Constraints.svelte";
import L11 from "../components/lessons/Improvements.svelte";
import L12 from "../components/lessons/ClosingThoughts.svelte";


const LessonStore = writable([
  {
    id: "BxESn",
    img: "/img/thumbnails/chapter1-BxESn.png",
    title: "An introduction to the Traveling Salesman Problem",
    desc: "You are the representative of a big company that sends you on a business trip through its main sites. Coincidentally, they are located in the ...",
    component: L1
  },
  {
    id: "m2MJl",
    img: "/img/thumbnails/chapter2-m2MJl.png",
    title: "QUBO problems",
    desc: "Before we can explore how quantum annealers work, there is an essential basic to be covered. For a quantum annealer to solve a task, it must be defined as ...",
    component: L3
  },
  {
    id: "xR66u",
    img: "/img/thumbnails/chapter2-xR66u.png",
    title: "How do quantum annealers work?",
    desc: "Equipped with the basic mathematics, we can now face the question: How do we get from an input to a result? The process of programming a quantum annealer ...",
    component: L4
  },
  {
    id: "yV8O6",
    img: "/img/thumbnails/chapter3-yV8O6.png",
    title: "Transforming the Traveling Salesman Problem for quantum annealers",
    desc: "Creating a quantum solution for the TSP is an exciting example of the versatility of quantum computing as well as a demonstration of ...",
    component: L5
  },
  {
    id: "0nRrT",
    img: "/img/thumbnails/chapter3-0nRrT.png",
    title: "Formulating the QUBO equation",
    desc: "From the example tour matrix in the previous lesson, the following rules for occupancy can be derived: 1. Exactly one occupation per row is allowed (since ...",
    component: L6
  },
  {
    id: "EFTOp",
    img: "/img/thumbnails/chapter3-EFTOp.png",
    title: "From coefficients to the Hamiltonian",
    desc: "The coefficients from the QUBO equation need to be transferred to the Hamiltonian in order to be a valid input for the quantum annealer. The result of ...",
    component: L7
  },
  {
    id: "m9UPL",
    img: "/img/thumbnails/chapter3-m9UPL.png",
    title: "How to design your own graphs",
    desc: "If you want to submit your own networks to the quantum annealer, you need to convert them to the Hamiltonian first. The tool Graph to Matrix, which can be ...",
    component: L8
  },
  {
    id: "okhMZ",
    img: "/img/thumbnails/chapter4-okhMZ.png",
    title: "Experimental results",
    desc: "When it comes to evaluating the performance of quantum algorithms, this often poses a problem because of the inherent non-deterministic nature of this method ...",
    component: L9
  },
  {
    id: "_Z9Gv",
    img: "/img/thumbnails/chapter4-_Z9Gv.png",
    title: "Where are the constraints?",
    desc: "This task however requires not only a large amount of further mathematical calculations, but also an intricate and founded knowledge of the QPU ...",
    component: L10
  },
  {
    id: "ufr4r",
    img: "/img/thumbnails/chapter4-ufr4r.png",
    title: "Possible improvements and optimizations",
    desc: "Since TSP solutions are closed loops that visit every city, the starting point can be set arbitrarily. So in theory, if we take this decision away from ...",
    component: L11
  },
  {
    id: "U7uiF",
    img: "",
    title: "Closing thoughts",
    desc: "With new milestones being achieved every year, quantum computing is a rapidly evolving technology that will have a major impact on our lives. It is currently ...",
    component: L12
  },
  {
    id: "eLyUg",
    img: "",
    title: "[TEMP] Demo card",
    desc: "This is a temporary card for testing features.",
    component: Demo
  },
  {
    id: "Z30Ce",
    img: "/img/thumbnails/chapter1-Z30Ce.png",
    title: "Graph theory",
    desc: "Computers only take numbers, so we need to use them as well. We already subconsciously drew a key concept of the solving method with the cities interconnected with ...",
    component: L2
  }
]);

export default LessonStore;